<template>
  <div class="mx-auto"
      style="width:300px; !important;">
      <br />
      <div id='instruction' class="rounded border border-info" v-if="showPart === 'instruction'">
          <br>
          Now, you are going to answer a few question about the task you just completed.
          <br>
          <br>
      </div>
      <div id='part1' class="rounded border border-info" v-if="showPart === 'part1'">
        <p class="text-dark">Part 1</p>
        <div class="text-dark text-left px-2">
          <p>Dose the medicine increase/ decrease/ have no influence on the level of
              *{{sypthoms[0]}}*?</p>
        <b-form-select v-model="selectedPart1[0]" :options="options">
        </b-form-select>
        </div>

        <br />
        <div class="text-dark text-left px-2">
          <p>Dose the medicine increase/ decrease/ have no influence on the level of
              *{{sypthoms[1]}}*?</p>
        <b-form-select v-model="selectedPart1[1]" :options="options">
        </b-form-select>
        </div>
        <br>
        <br>
      </div>
        <div id='part2' v-if="showPart === 'part2'">
        <p class="text-dark">Part 2</p>
        <div class="text-dark text-left p-2 rounded border border-info">
          <p>1 - Please estimated the average level of *{{sypthoms[0]}}* before taking medicine
              (first 12 days)?</p>
        <b-form-input
        id="range-0"
        v-model="selectedPart2[0]"
        type="range" min="0" max="100">
        </b-form-input>
        <div class="mt-2">You selected: {{ selectedPart2[0] }}</div>
        </div>
        <br>
        <div class="text-dark text-left p-2 rounded border border-info">
          <p>2 - Please estimated the average level of *{{sypthoms[1]}}* before taking medicine
              (first 12 days)?</p>
        <b-form-input
        id="range-1"
        v-model="selectedPart2[1]"
        type="range" min="0" max="100">
        </b-form-input>
        <div class="mt-2">You selected: {{ selectedPart2[1] }}</div>
        </div>
        <br>
        <div class="text-dark text-left p-2 rounded border border-info">
          <p>3 - Please estimated the average level of *{{sypthoms[0]}}* after taking medicine
              (last 12 days)?</p>
        <b-form-input
        id="range-2"
        v-model="selectedPart2[2]"
        type="range" min="0" max="100">
        </b-form-input>
        <div class="mt-2">You selected: {{ selectedPart2[2] }}</div>
        </div>
        <br>
        <div class="text-dark text-left p-2 rounded border border-info">
          <p>4 - Please estimated the average level of *{{sypthoms[1]}}* after taking medicine
              (last 12 days)?</p>
        <b-form-input
        id="range-3"
        v-model="selectedPart2[3]"
        type="range" min="0" max="100">
        </b-form-input>
        <div class="mt-2">You selected: {{ selectedPart2[3] }}</div>
        </div>
        </div>
        <br />
        <br>
                <b-button
            v-on:click="goNext"
            class="rounded-pill"
            :variant="nextVariant"
            v-if="showNext"
            :disabled='isDisabledNext'
            >Next</b-button>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Questions',
  data() {
    return {
      isDisabledNext: false,
      nextVariant: 'info',
      showNext: true,
      selectedPart1: [null, null],
      selectedPart2: [null, null, null, null],
      showPart: 'instruction',
      options: [{ value: null, text: 'Please select an option' }],
      sypthoms: [],
    };
  },
  methods: {
    getData() {
    //   const path = '/task';
      const path = 'http://localhost:8080/task';
      axios
        .get(path)
        .then((res) => {
          console.log(res.data.isLogged);
          if (!res.data.isLogged) {
            this.$router.push({ name: 'Login' });
          } else {
            this.sypthoms = res.data.sypthoms;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    createOptions() {
      for (let i = -10; i < 11; i += 1) {
        if (i === -10) {
          this.options.push({ value: i, text: '-10(strongly decrease)' });
        } else if (i === 0) {
          this.options.push({ value: i, text: '0(no influence)' });
        } else if (i === 10) {
          this.options.push({ value: i, text: '10(strongly increase)' });
        } else {
          this.options.push({ value: i, text: i });
        }
      }
    },

    goNext() {
      switch (this.showPart) {
        case 'instruction':
          this.showPart = 'part1';
          break;
        case 'part1':
          this.showPart = 'part2';
          break;
        default:
          this.nextVariant = 'secondary';
          this.isDisabledNext = true;
      }
    },
  },
  created() {
    this.getData();
    this.createOptions();
  },
};
</script>
